module.exports = __webpack_public_path__ + "static/add_csv_and_excel_menu-c04cc4d0715cc7d393bf0d9746aae951.png";